/**
 * The release version from version.json, shown on the sign-in box and in every footer.
 * Compact for a footer, with the build date in the tooltip; `expandable` shows it on expand instead.
 */
export function AppVersion({
  className,
  expandable = false,
  version: release = __APP_VERSION__,
}: {
  className?: string
  expandable?: boolean
  version?: typeof __APP_VERSION__
}) {
  const { version, gitCommit, buildDate } = release
  const label = (version === 'dev' ? 'dev' : `v${version}`) + (gitCommit ? ` (${gitCommit})` : '')
  const built = `Built: ${buildDate ?? 'Not available'}`
  if (expandable) {
    return (
      <details className={className} data-testid="app-version">
        <summary>{label}</summary>
        <div>{built}</div>
      </details>
    )
  }
  return (
    <span className={className} title={built} data-testid="app-version">
      {label}
    </span>
  )
}
